import React from "react";

export const PencilIcon = () => {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.5947 7.90415L12.4162 6.72564L5.2095 13.9324L4.64298 15.6774L6.38802 15.1109L13.5947 7.90415ZM7.28344 16.5725L2.04834 18.272L3.7479 13.0369L12.4162 4.36862L15.9518 7.90415L7.28344 16.5725Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M17.1303 2.01159C16.4794 1.36072 15.4242 1.36072 14.7733 2.01159L13.5948 3.1901L17.1303 6.72564L18.3088 5.54713C18.9597 4.89625 18.9597 3.84098 18.3088 3.1901L17.1303 2.01159Z" fill="currentColor" />
    </svg>

}